import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
export const Right = styled.div`
  display: flex;
  flex-direction: column;
`;